var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dl',{staticClass:"accordion box",attrs:{"role":"presentation"}},_vm._l((_vm.content),function(item,index){return _c('accordion-item',{key:index,attrs:{"multiple":_vm.multiple,"item":item,"index":index,"groupId":_vm.groupId}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }